import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppShell } from '@/presentation/layouts/AppShell';
import { useLangSync } from '@/presentation/hooks/useLangSync';
const HomePage = lazy(() => import('@/presentation/pages/HomePage'));
const LegalPage = lazy(() => import('@/presentation/pages/LegalPage'));
const HowToPage = lazy(() => import('@/presentation/pages/HowToPage'));
const PlatformDownloadPage = lazy(() => import('@/presentation/pages/PlatformDownloadPage'));
const NotFoundPage = lazy(() => import('@/presentation/pages/NotFoundPage'));
export default function App() {
    useLangSync();
    return (_jsx(AppShell, { children: _jsx(Suspense, { fallback: null, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/how-to", element: _jsx(HowToPage, {}) }), _jsx(Route, { path: "/download/:platform", element: _jsx(PlatformDownloadPage, {}) }), _jsx(Route, { path: "/legal", element: _jsx(LegalPage, {}) }), _jsx(Route, { path: "*", element: _jsx(NotFoundPage, {}) })] }) }) }));
}
